var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModalCrear",
        {
          attrs: { titulo: _vm.modal_title },
          on: { cerrar: _vm.handleCloseModal }
        },
        [
          _c(
            "v-btn",
            {
              staticClass: "button",
              attrs: { id: "btnGuardar" },
              on: { click: _vm.handleSaveComand }
            },
            [
              _c(
                "span",
                { staticClass: "text" },
                [_vm._t("default", [_vm._v("Guardar")])],
                2
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.pasos.informacionGeneral.step
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticStyle: {
                        "margin-bottom": "-10px !important",
                        "margin-top": "6px !important"
                      },
                      attrs: { small: "" }
                    },
                    [_vm._v(_vm._s(_vm.getIconModal) + "\n        ")]
                  ),
                  _c("span", [_vm._v(_vm._s(_vm.modal_title))])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "cardnew", attrs: { align: "center" } }, [
        _c("br"),
        _c(
          "div",
          { attrs: { id: "formDiv" } },
          [
            _c(
              "v-flex",
              { attrs: { md10: "" } },
              [
                _c(
                  "v-card",
                  { staticClass: "rounded-card" },
                  [
                    _c(
                      "v-form",
                      {
                        ref: "form",
                        staticClass: "col-md-12",
                        attrs: { "lazy-validation": "" },
                        model: {
                          value: _vm.isFormValid,
                          callback: function($$v) {
                            _vm.isFormValid = $$v
                          },
                          expression: "isFormValid"
                        }
                      },
                      [
                        _c(
                          "v-container",
                          { attrs: { "grid-list-md": "" } },
                          [
                            _c(
                              "FormFieldsContainer",
                              { attrs: { titulo: _vm.modal_title } },
                              [
                                _vm._t("prependInformacionGeneral"),
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm6: "", md6: "" } },
                                  [
                                    _c("v-combobox", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.marca.label,
                                        items: _vm.formFields.marca.items,
                                        "item-text": "configvalor",
                                        "item-value": "configid",
                                        disabled: _vm.modal_action == "editar"
                                      },
                                      on: {
                                        input: _vm.handleInputValue,
                                        change: _vm.loadModel
                                      },
                                      model: {
                                        value: _vm.formFields.marca.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.marca,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.marca.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm6: "", md6: "" } },
                                  [
                                    _c("v-combobox", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.modelo.label,
                                        items: _vm.formFields.modelo.items,
                                        "item-text": "configvalor",
                                        "item-value": "configid",
                                        disabled: _vm.modal_action == "editar"
                                      },
                                      on: { input: _vm.handleInputValue },
                                      model: {
                                        value: _vm.formFields.modelo.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.modelo,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.modelo.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm6: "", md6: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|co2|max:10",
                                          expression: "'required|co2|max:10'"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.emision_co2.label,
                                        "error-messages": _vm.errors.collect(
                                          "co2"
                                        ),
                                        "data-vv-name": "co2",
                                        required: ""
                                      },
                                      on: { input: _vm.handleInputValue },
                                      model: {
                                        value: _vm.formFields.emision_co2.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.emision_co2,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.emision_co2.value"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }